/**
 * Описание иерархии роутов (в какой странице какая страница рендерится)
 */
import {IRouteShape} from '@eda.yandex/web-router'
import {RouterEnv} from 'admin/types'
import App from 'admin/pages/App'
import CTT from 'admin/pages/CTT'
import ShiftsTotalReport from 'admin/pages/CTT/ShiftsTotalReport'

const routes: Array<IRouteShape<RouterEnv>> = [{
  path: '/',
  viewConfig: App,
  routes: [
    {
      path: '/ctt/',
      viewConfig: CTT,
      routes: [
        {
          path: '/ctt/shift-totals-report/?region&zone&from&to',
          viewConfig: ShiftsTotalReport
        },
        {
          path: '*',
          redirectTo: '/ctt/shift-totals-report'
        }
      ]
    },
    {
      path: '*',
      redirectTo: '/ctt'
    }
  ]
}]

export default routes
